<template>
    <div>
        <Title title="新闻" :path="formPath"/>

        <div class="page-loading" v-if="init === true">
            <van-skeleton title :row="8" />
        </div>
        <div class="main" v-else>
<!--                <div class="newsnav" v-if="class_list.length>0">-->
<!--                    <router-link v-for="(c, i) in class_list" :key="i" :to="'/news/'+ c.zid" :class="class_object.id === c.id?'curr':''">{{ c.name }}</router-link>-->
<!--                </div>-->

            <div class="newsnav">
                <van-tabs v-model="tabs_active">
                    <van-tab v-for="(c,i) in class_list" :key="i" :title="c.name"/>
                </van-tabs>
            </div>

                <template v-if="list.length>0">
                    <div :class="['newslist', 'newslist_type'+class_object.group]">
                        <ul>
                            <li v-for="(c, i) in list" :key="i">
                                <div v-if="class_object.group === 4"><router-link :to="'/news/v/'+ c.id">{{ c.title }}</router-link></div>
                                <div v-else-if="class_object.group === 3 || class_object.group === 1">
                                    <router-link :to="'/news/v/'+ c.id">{{ c.title }}</router-link><span>{{ c.time }}</span></div>
                                <div v-else-if="class_object.group === 2"><a :href="'/news/v/'+ c.id" target="_blank">{{ c.title }}</a></div>
                            </li>
                        </ul>
                    </div>
<!--                    <el-pagination-->
<!--                            background-->
<!--                            layout="prev,pager,next"-->
<!--                            :total="total"-->
<!--                            :size="size"-->
<!--                            v-if="total>0"-->
<!--                            @current-change="goPage" />-->
                </template>
                <el-empty v-else />
        </div>

    </div>
</template>

<script>
    import Title from './../components/public/title'
    import "../assets/css/news.css"
    export default {
        name: "index",
        components: {
            Title
        },
        watch: {
            // '$route': {
            //     handler (router) {
            //         // console.log(router)
            //         this.name = router.params.name
            //         // this.init = true
            //         this.page = 1
            //         this.total = 0
            //         this.size = 0
            //         this.getData()
            //     }
            // }
            tabs_active(i){
                let zid = this.class_list[i].zid
                this.name = zid
                this.page = 1
                this.getData()
            }
        },
        data() {
            return {
                name: '',
                page: 1,
                init: true,
                class_object: null,
                class_list: [],
                list: [],
                total: 0,
                size: 0,
                tabs_active: 0,
                formPath: ''
            }
        },
        activated() {
            let name = this.$route.params.name
            if(this.name === '') {
                this.name = name
                this.getData()
            }
        },
        methods: {
            getData(){
                let that = this
                // console.log(that.page)
                that.$get(that.$api.news_class, {name: that.name, page: that.page}).then(function (res) {
                    // console.log(res.data)
                    if(res.code === 1){
                        that.list = []

                        that.list = res.data.list
                        that.class_object = res.data.class_object
                        that.class_list = res.data.class_list
                        that.total = res.data.total
                        that.size = res.data.size
                        that.$backTop()

                        that.setClassActive()
                    }
                    that.init = false
                }).finally(function () {
                    that.init = false
                })
            },
            setClassActive(){
                let that = this
                that.class_list.forEach(function (c, i) {
                    if(that.class_object.id === c.id){
                        that.tabs_active = i
                    }
                })
            },
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                if(form.name === 'index'){
                    vm.name = ''
                }
                if(form.path.indexOf('news') > -1)
                    vm.formPath = '/'
                else
                    vm.formPath = form.path
            })
        },
    }
</script>

<style scoped>
</style>
